export default "__VITE_ASSET__e7263e8b__"